export class LampEasySearchJsEnv {
  refinementSearchElements: RefinementSearchElement[];
  hasRefinementSearchElements: boolean;
  selectedModel: string;
  inputWord: string;

  constructor(
    refinementSearchElements: RefinementSearchElement[],
    selectedModel: string,
    inputWord: string
  ) {
    this.refinementSearchElements = refinementSearchElements;
    this.hasRefinementSearchElements = refinementSearchElements.length !== 0;
    this.selectedModel = selectedModel;
    this.inputWord = inputWord;
  }
}

export class RefinementSearchElement {
  refinementSearchDisplayName: string;
  refinementSearchParameter: string;

  constructor(
    refinementSearchDisplayName: string,
    refinementSearchParameter: string
  ) {
    this.refinementSearchDisplayName = refinementSearchDisplayName;
    this.refinementSearchParameter = refinementSearchParameter;
  }
}